import styled from 'styled-components';
import { customMediaQuery } from 'students/views/shared/styled';

export const SWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const SErrorWrapper = styled(SWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  background: rgba(0, 0, 0, 0.4);
`;

export const SErrorTitle = styled.h2`
  color: var(--color-white);
  text-align: center;
  font-size: 1.25rem;
  padding: 0 1rem;
  margin: 0;

  ${customMediaQuery('tablet')} {
    font-size: 1.75rem;
  }
`;

export const SErrorRetryButton = styled.button`
  min-height: 44px;
  padding: 0 1.25rem;
  border: 2px solid var(--color-white);
  border-radius: 22px;
  background: transparent;
  color: var(--color-white);
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  &:focus-visible {
    outline: 2px solid var(--color-white);
    outline-offset: 2px;
  }
`;
